import {AppThunk} from '../store/types';
import {ProjectShortInfoResponse} from '../api/apiContracts';
import {getProjectShortInfos} from '../api/apiClient';
import {setProjectShortInfosAction} from '../store/projectShortInfo/actions';

export const loadProjectShortInfos = (): AppThunk<Promise<void>> => async dispatch => {
    const projectShortInfos: ProjectShortInfoResponse[] = await getProjectShortInfos();
    dispatch(setProjectShortInfosAction(projectShortInfos));
};
